import { jsx as m } from "react/jsx-runtime";
import { c as t } from "../../../index-Cu0xwYjD.js";
import { s } from "../../../Grid.module-_d_yvtu8.js";
const f = ({
  children: o,
  className: r,
  isNested: e = !1
}) => /* @__PURE__ */ m(
  "div",
  {
    className: t(
      s.row,
      { [s.isNested]: e },
      r
    ),
    children: o
  }
);
export {
  f as Row
};
